// extracted by mini-css-extract-plugin
module.exports = {"root":"VisualWorkflow_root__1gOQW"};